import React from 'react';
import { createIconElement } from '@/lib';
import { ChatDropdown } from './ChatDropdown';
import { ChatSession } from '../types/askStanley.types';
import IcWrite from '@/assets/icons/ic-Write.svg';
import IcXClose from '@/assets/icons/ic-x-close.svg';

interface ChatHeaderProps {
    currentChatTitle: string;
    onClose: () => void;
    onCreateNewChat: () => void;
    onChatSelect: (chatId: string | number) => void;
    chats: ChatSession[];
    showChatDropdown: boolean;
    onToggleChatDropdown: () => void;
    onCloseChatDropdown: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
    currentChatTitle,
    onClose,
    onCreateNewChat,
    onChatSelect,
    chats,
    showChatDropdown,
    onToggleChatDropdown,
    onCloseChatDropdown,
}) => {
    return (
        <div className='bg-brand-dimmed flex items-center justify-between p-4 lg:rounded-t-lg'>
            <div className='flex w-full items-center gap-2'>
                {/* Mobile: X button first, Desktop: New chat button first */}
                <button
                    onClick={onClose}
                    className='text-brand-main hover:text-brand-dark hover:bg-neutral-subtle cursor-pointer rounded-full p-1.5 transition-colors lg:hidden'
                    aria-label='Close chat'
                >
                    {createIconElement(IcXClose, { className: 'size-6' })}
                </button>

                <button
                    onClick={onCreateNewChat}
                    className='text-brand-main hover:text-brand-dark hover:bg-neutral-subtle hidden cursor-pointer rounded-full p-1.5 transition-colors lg:block'
                    aria-label='New chat'
                >
                    {createIconElement(IcWrite, { className: 'size-6' })}
                </button>

                <ChatDropdown
                    currentChatTitle={currentChatTitle}
                    chats={chats}
                    showDropdown={showChatDropdown}
                    onToggleDropdown={onToggleChatDropdown}
                    onChatSelect={onChatSelect}
                    onCloseDropdown={onCloseChatDropdown}
                />

                <button
                    onClick={onCreateNewChat}
                    className='text-brand-main hover:text-brand-dark hover:bg-neutral-subtle cursor-pointer rounded-full p-1.5 transition-colors lg:hidden'
                    aria-label='New chat'
                >
                    {createIconElement(IcWrite, { className: 'size-6' })}
                </button>

                <button
                    onClick={onClose}
                    className='text-brand-main hover:text-brand-dark hover:bg-neutral-subtle hidden cursor-pointer rounded-full p-1.5 transition-colors lg:block'
                    aria-label='Close chat'
                >
                    {createIconElement(IcXClose, { className: 'size-6' })}
                </button>
            </div>
        </div>
    );
};
